export enum PostPurchaseBrandConnectActionTypes {
  FETCH_REQUEST = 'postPurchaseBrandConnect/FETCH_REQUEST',
  FETCH_SUCCESS = 'postPurchaseBrandConnect/FETCH_SUCCESS',
  FETCH_ERROR = 'postPurchaseBrandConnect/FETCH_ERROR',
}

export interface IPostPurchaseBrandConnectAnalytics {
  traffic_source: string
  impressions: number | null
  engaged_views: number | null
  watch_time_hours: number | null
  avg_view_duration_secs: number | null
  avg_view_percentage: number | null
  reach: number | null
  likes: number | null
  comments: number | null
  playlist_adds: number | null
  shares: number | null
  engagement_pct: number | null
}

export type PostPurchaseBrandConnectAnalyticsMetrics = Omit<
  IPostPurchaseBrandConnectAnalytics,
  'traffic_source'
>

export interface IPostPurchaseAnalyticsState {
  brandConnectAnalyticsBySubmissionId: Record<number, IPostPurchaseBrandConnectAnalytics[]>
  isFetching: boolean
  errors: unknown
}
